import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { API_URL } from "../../config/config";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get the token (from Redux state, sessionStorage, or localStorage)
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

// Async thunk to fetch alerts for a user (nurse)
export const fetchAlertsByUser = createAsyncThunk(
  "alerts/fetchByUser",
  async (userId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/alerts/alerts/user/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

export const fetchAllAlerts = createAsyncThunk(
  "alerts/fetchAll",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(`${API_URL}/alerts/get-alert/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

export const acknowledgeAlertById = createAsyncThunk(
  "alerts/acknowledgeById",
  async (alertId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.put(
        `${API_URL}/alerts/alerts/${alertId}/acknowledge`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return alertId; // returning alertId for Redux state update
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

const alertSlice = createSlice({
  name: "alerts",
  initialState: {
    alerts: [],
    loading: false,
    error: null,
  },
  reducers: {
    acknowledgeAlert(state, action) {
      const alertId = action.payload;
      const alert = state.alerts.find((a) => a.id === alertId);
      if (alert) {
        alert.acknowledged = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlertsByUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAlertsByUser.fulfilled, (state, action) => {
        state.loading = false;
        state.alerts = action.payload;
      })
      .addCase(fetchAlertsByUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // fetch all alerts
      .addCase(fetchAllAlerts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllAlerts.fulfilled, (state, action) => {
        state.loading = false;
        state.alerts = action.payload;
      })
      .addCase(fetchAllAlerts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // acknowledge alert
      .addCase(acknowledgeAlertById.fulfilled, (state, action) => {
        const alertId = action.payload;
        const alert = state.alerts.find((a) => a.id === alertId);
        if (alert) {
          alert.acknowledged = true;
        }
      });
  },
});

export const { acknowledgeAlert } = alertSlice.actions;
export default alertSlice.reducer;



// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// // import { API_URL } from "../../config/config"; // Adjust path based on your project structure
// import axios from "axios";

// const API_URL = process.env.REACT_APP_API_URL;

// // Async thunk to fetch alerts for a user (nurse)
// export const fetchAlertsByUser = createAsyncThunk(
//   "alerts/fetchByUser",
//   async (userId, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/alerts/alerts/user/${userId}`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.detail || error.message);
//     }
//   }
// );

// export const fetchAllAlerts = createAsyncThunk(
//   "alerts/fetchAll",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/alerts/get-alert/`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.detail || error.message);
//     }
//   }
// );

// export const acknowledgeAlertById = createAsyncThunk(
//   "alerts/acknowledgeById",
//   async (alertId, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(
//         `${API_URL}/alerts/alerts/${alertId}/acknowledge`
//       );
//       return alertId; // returning alertId for Redux state update
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.detail || error.message);
//     }
//   }
// );

// const alertSlice = createSlice({
//   name: "alerts",
//   initialState: {
//     alerts: [],
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     acknowledgeAlert(state, action) {
//       const alertId = action.payload;
//       const alert = state.alerts.find((a) => a.id === alertId);
//       if (alert) {
//         alert.acknowledged = true; // Local state update, ideally sync with backend
//       }
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // fetch alerts by user
//       .addCase(fetchAlertsByUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAlertsByUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.alerts = action.payload;
//       })
//       .addCase(fetchAlertsByUser.rejected, (state, action) => {
//         console.log("Fetched alerts from API:", action.payload); // Debug
//         state.loading = false;
//         state.error = action.error.message;
//       })
//       // fetch all alerts (new)
//       .addCase(fetchAllAlerts.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAllAlerts.fulfilled, (state, action) => {
//         state.loading = false;
//         state.alerts = action.payload; // replace alerts list with all alerts
//       })
//       .addCase(fetchAllAlerts.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message;
//       })
//       //extraReducers to handle the acknowledge action
//       .addCase(acknowledgeAlertById.fulfilled, (state, action) => {
//         const alertId = action.payload;
//         const alert = state.alerts.find((a) => a.id === alertId);
//         if (alert) {
//           alert.acknowledged = true;
//         }
//       });
//   },
// });

// export const { acknowledgeAlert } = alertSlice.actions;

// export default alertSlice.reducer;
